import { useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";

import { employeeStore } from "./store";
import { getEmployee, getUserIdentifier } from "./getters";
import { type UserIdentifier, type EmployeeStore } from "./store.types";

export function useEmployee(): EmployeeStore {
  return useStore(employeeStore, useShallow(getEmployee));
}

export function useEmployeeIdentifier(): UserIdentifier | null {
  return useStore(employeeStore, useShallow(getUserIdentifier));
}

export function useIsEmployeeAuthenticated(): boolean {
  return useStore(employeeStore, useShallow(getUserIdentifier)) !== null;
}
